import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useStopGeneratingAction } from '#pplx/frontend/apps/ask/ask-input/ask-input-voice/components/StopButtonShared.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
export const StopButton = React.memo(function StopButton({ onStopButtonClick, isAskInputFocused = false, pill = false, entryId, }) {
    const { handleStop: handleClick, isStopInFlight, stopLabel, } = useStopGeneratingAction({
        isShortcutEnabled: isAskInputFocused,
        onStop: onStopButtonClick,
        resetKey: entryId,
    });
    return (_jsx("span", { className: "contents", children: _jsx(Button, { "aria-label": stopLabel, variant: "tonal", icon: $icon('player-stop-filled'), onClick: handleClick, isLoading: isStopInFlight, size: "small", rounded: pill }) }));
});
//# sourceMappingURL=StopButton.js.map